import React from 'react';
import PropTypes from 'prop-types';


const IELoading = ({ message }) => {
  return (
    <div className="ie--loading">
      {message}
    </div>
  );
};

IELoading.propTypes = {
  message: PropTypes.string,
};

IELoading.defaultProps = {
  message: 'loading...',
};

export default IELoading;
